module.exports = __webpack_public_path__ + "static/img/s103.8f14ad09.png";